import React from 'react';

function PriceConditions({ pricing, showAll }) {
  const conditions = [];
  pricing.equipments?.forEach(p => {
    if (p.hasNewPrice && p.newPrice.conditions) {
      p.newPrice.conditions.forEach(c => {
        if ((showAll || c.showMessage) && !conditions.includes(c.title)) {
          conditions.push(c.title);
        }
      })
    }
  });

  return conditions.length ? (
    <div className="alert alert-success pb-0">
      <ul>
        {conditions.map(condition => (
          <li>{condition}</li>
        ))}
      </ul>
    </div>
  ) : null;
}

export default PriceConditions;